import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Import desktop styles
import './desktop/styles/base.css';
import './desktop/styles/ui.css';
import './desktop/styles/layout.css';
import './desktop/styles/components.css';
import './desktop/styles/editPanel.css';
import './desktop/styles/chatbot.css';
import './desktop/styles/billing.css';
import './desktop/styles/legal.css';
import './desktop/styles/blog.css';

// Import mobile styles
import './mobile/styles/mobile-base.css';
import './mobile/styles/mobile-layout.css';
import './mobile/styles/mobile-components.css';
import './mobile/styles/mobile-chatbot.css';
import './mobile/styles/mobile-editpanel.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
